module.exports = __webpack_public_path__ + "img/tech13.37efe329.png";